import React from "react";

export default function HomeMsg() {
  return (
    <div
      className="alert alert-warning mx-auto mt-5"
      style={{ maxWidth: "20rem" }}
    >
      <h3 className="alert-heading text-center text-black">
        Let's add some heroes!
      </h3>
    </div>
  );
}
